import { render, staticRenderFns } from "./RosterReport.vue?vue&type=template&id=671d0f7a&scoped=true"
import script from "./RosterReport.vue?vue&type=script&lang=js"
export * from "./RosterReport.vue?vue&type=script&lang=js"
import style0 from "./RosterReport.vue?vue&type=style&index=0&id=671d0f7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671d0f7a",
  null
  
)

export default component.exports